var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnQq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "btn_float_qq") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875-\\u4EA4\\u4E92\\u7EC6\\u8282",
    transform: "translate(-370.000000, -674.000000)",
    fill: "#3D80FA"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9ED8\\u8BA4",
    transform: "translate(359.000000, 621.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u670D\\u52A1\\u54A8\\u8BE2",
    transform: "translate(0.000000, 38.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-16",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    opacity: 0,
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "tab_qq",
    transform: "translate(14.000000, 13.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5142034,15.1602262 C17.2078886,15.5419416 16.4020451,15.0848256 15.7847029,13.8171536 C15.6291893,14.3920829 15.2474739,15.3157399 14.3662298,16.4655985 C15.8271157,16.8096136 16.2088311,18.2327992 15.7470026,19.0009425 C15.4029876,19.5381715 14.6348443,20 13.2917717,20 C10.8742411,20 9.83748332,19.3496701 9.33795457,18.8878417 C9.26255401,18.7747408 9.10704034,18.732328 8.91382639,18.732328 C8.72061244,18.732328 8.60751159,18.7700283 8.48969821,18.8878417 C8.02786975,19.3496701 6.95341169,20 4.53588106,20 C3.19280848,20 2.38696494,19.5381715 2.08065014,19.0009425 C1.5811214,18.2327992 2.00524958,16.8143261 3.461423,16.4655985 C2.61787917,15.3157399 2.23145127,14.3920829 2.04294986,13.8171536 C1.46802055,15.0848256 0.624476721,15.5843544 0.313449388,15.1602262 C0.0825351563,14.8162111 -0.0305656919,14.0857681 0.00713459084,13.5862394 C0.162648257,11.6682375 1.42560773,10.0565504 2.19375099,9.2130066 C2.08065014,8.98209237 1.84973591,7.56361923 2.80638059,6.60226202 L2.80638059,6.52686145 C2.80638059,2.72855796 5.49252573,0 8.90911386,0 C12.2880017,0 15.0118471,2.72384543 15.0118471,6.52686145 L15.0118471,6.60226202 C15.9732043,7.56361923 15.7422901,8.98209237 15.6244767,9.2130066 C16.3549197,10.0565504 17.660292,11.6682375 17.8110931,13.5862394 C17.862931,14.0857681 17.7828179,14.8114986 17.5142034,15.1602262 L17.5142034,15.1602262 Z",
    id: "\\u8DEF\\u5F84"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnQq);
export default __webpack_public_path__ + "static/media/btn_qq.525a4820af1cc558ac781150b9f68035.svg";
export { ForwardRef as ReactComponent };